<template>
    <div class="inspection">
        <h2>Пальпация</h2>
        <div class="inspection-header">
            <h3>Система организма</h3>
            <div class="header-icons">
                <div
                    class="preloader"
                    v-for="(el, ind) in getDiagnostic.iconsList"
                    :key="'C'+ind"
                >
                    <div
                        :class="[
                            nameSystemClick.nameLong === el.nameLong ? 'active' : '',
                            bodySystemDisabled(el.id) ? 'disabled_icon' : 'icon'
                        ]"
                        @click="bodySystemDisabled(el.id) ? '' : clickSystemFilter(el, 'nameSystemClick')"
                        :title="el.nameLong"
                    >
                        <inline-svg :src="require(`@/assets/SystemMini/${el.icon}`)" />
                        {{ el.name }}
                    </div>

                    <v-overlay :value="el.loading || loadAll" absolute>
                        <v-progress-circular indeterminate size="30" />
                    </v-overlay>
                </div>
            </div>
        </div>

        <div class="inspection-filters">
            <!-- <v-autocomplete
                label=""
                placeholder="Выберите группу"
                clearable
                item-value="id"
                item-text="name"
                multiple
                outlined
                hide-details
                @change="selectedGroup"
                v-model="params.groupIds"
                :loading="loadListGroup"
                :items="listGroup"
            /> -->

            <AutocompleteComponents
                :loading="loadListGroup || loadingClick"
                :items="listGroup"
                :clearable="true"
                :multiple="true"
                item-text="name"
                placeholder="Выберите группу"
                @change="selectedGroup"
                @hideOrShowGroup="viewOrNot"
                :optionsApi="{
                    url: 'DiaTest/UpdateSomaticStatusesVisible',
                    physResearchId: isCurrentObjSprPhysResearch
                }"
            />

            <v-autocomplete
                label=""
                clearable
                :placeholder="isDisabledProperty ? 'Выберите группу для отображения показателей' : 'Выберите показатель'"
                item-value="id"
                item-text="name"
                multiple
                outlined
                @change="filter(nameSystemClick, false, true)"
                hide-details
                v-model="params.propertyIds"
                :disabled="isDisabledProperty"
                :items="listProperty"
            />
        </div>

        <div class="inspection-filters">
            <v-checkbox v-model="viewOpenIndicators" @change="showOnlyOpenIndicators(viewOpenIndicators)" label="Показать только открытые показатели" />
        </div>

        <div class="inspection-body">
            <div class="body-left">
                <!-- Локальный статус -->
                <div v-show="isDataSomaticStatuses > 0 && !loadAll" class="body-item">
                    <div class="item-line">
                        <div class="item-combo">
                            <p>Локальный статус</p>
                            <v-textarea
                                rows="4"
                                outlined
                                :disabled="getFlagReadonly"
                                hide-details
                                v-model="localyStatusSystem"
                                @input="saveLocalyStatus({
                                    obj: {
                                        diaTestId: $route.params.id,
                                        bodySystemId: nameSystemClick.id,
                                        physResearchId: getDiagnostic.currentObjSprPhysResearch.id,
                                        note: localyStatusSystem
                                    },
                                    url: 'DiaTest/AddOrUpdateLocalStatus'
                                })"
                            />
                        </div>
                    </div>
                </div>

                <div
                    v-show="isDataSomaticStatuses > 0 && !loadAll"
                    v-for="(el, inx) in getDiagnostic.dataSomaticStatuses"
                    :key="'U'+inx"
                    class="body-item"
                >
                    <div class="item-line">
                        <div class="item-combo">
                            <p>Группа</p>
                            <input :disabled="!el.isVisible" v-model="el.groupName" readonly type="text">
                        </div>
                        <div class="item-combo">
                            <p>Наименование</p>
                            <input :disabled="!el.isVisible" v-model="el.propertyName" readonly type="text">
                        </div>
                    </div>
                    <div class="item-line">
                        <div class="item-combo">
                            <p>Заключение</p>
                            <input :disabled="!el.isVisible" v-show="!el.edite && el.valueType === 0" :value="el.avgValue" readonly type="number">
                            <input :disabled="!el.isVisible" v-show="!el.edite && el.valueType === 1" :value="el.listValueName" readonly type="text">

                            <input
                                v-show="el.edite && el.valueType === 0"
                                v-model="el.avgValue"
                                :ref="`input-${el.id}${inx}`"
                                type="number"
                                @input="save({ obj: el, url: 'DiaTest/AddOrUpdateSomaticStatus' })"
                            >

                            <v-autocomplete
                                label=""
                                v-show="el.edite && el.valueType === 1"
                                outlined
                                height="46"
                                hide-details
                                :rules="[rules.required]"
                                :items="el.listValues"
                                :loading="el.loadSpr"
                                @change="save({ obj: el, url: 'DiaTest/AddOrUpdateSomaticStatus' }); setListValue(el)"
                                :placeholder="el.loadSpr ? 'Данные подгружаются из справочника...' : 'Выбрать значение'"
                                :no-data-text="el.loadSpr ? 'Ждите, данные подгружаются из справочника...' : 'Отсутствуют данные'"
                                item-text="name"
                                item-value="id"
                                class="item-combo__select"
                                v-model="el.listValueId"
                            />
                        </div>
                        <div class="item-combo">
                            <p>Единица измерения</p>
                            <input :disabled="!el.isVisible" v-model="el.measurementName" readonly type="text">
                        </div>
                    </div>
                    <div class="item-line item-btn">
                        <div class="item-combo btn-horiz">
                            <div class="switch horiz mb-0">
                                <p>Патология</p>
                                <div class="switch-item">
                                    <span>Нет</span>
                                    <v-switch
                                        disabled
                                        v-model="el.isPathology"
                                        :loading="el.loadPatalogy"
                                        @change="switchIsVisibleOrPatalogy({ obj: el, url: 'DiaTest/AddOrUpdateSomaticStatus' }, 'loadPatalogy', null)"
                                    />
                                    <span>Да</span>
                                </div>
                            </div>
                        </div>
                        <div class="item-combo right">
                            <v-btn
                                class="btn-load__edite custom-button"
                                height="46"
                                x-small
                                :loading="el.loadingImage"
                                :class="{ 'btn-load__disabled': !el.isVisible }"
                                :disabled="!el.isVisible"
                                type="button"
                                @click.prevent="el.isVisible ? selectedProperty(el) : ''"
                            >
                                {{ getFlagReadonly ? 'Посмотреть прикрепленные файлы' : 'Прикрепить файл' }}
                            </v-btn>
                            <v-btn
                                v-if="!getFlagReadonly"
                                :loading="el.loadVisible"
                                @click="switchIsVisibleOrPatalogy({ obj: el, url: 'DiaTest/AddOrUpdateSomaticStatus' }, 'loadVisible', 'isVisible')"
                                class="btn-load__view"
                                height="46"
                                :title="el.isVisible ? 'Скрыть' : 'Показать'"
                            >
                                <v-icon> {{ !el.isVisible ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                            </v-btn>

                            <v-btn
                                v-if="!getFlagReadonly"
                                :loading="el.loadSpr"
                                :disabled="!el.isVisible"
                                class="custom-button"
                                @click="getData(el, inx, 'SprSomaticStatus')"
                                :class="{
                                    'btn-load__edite': true,
                                    'btn-load__disabled': !el.isVisible
                                }"
                                height="46"
                                :title="el.edite ? 'Закрыть' : 'Редактировать'"
                            >
                                <v-icon> {{ el.edite ? 'mdi-close' : 'mdi-pencil' }}</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>

                <Observer v-if="isDataSomaticStatuses > 0">
                    <template slot="showMore">
                        <div class="text" @click="showMoreFunc(params)">
                            <span class="text__info" v-if="showMoreFinish">
                                Всего записей: {{ isDataSomaticStatuses }}
                            </span>
                            <span class="text__btn" v-else>
                                Показать еще {{ params.pageSize }}
                            </span>

                            <v-overlay :value="loadingShowMore" absolute opacity="0.2">
                                <v-progress-circular indeterminate size="25" />
                            </v-overlay>
                        </div>

                    </template>
                </Observer>

                <v-skeleton-loader
                    v-for="item in 4"
                    :key="item"
                    v-show="(loadAll || loadingClick) && isDataSomaticStatuses === 0"
                    type="list-item-three-line"
                />

                <p v-show="isDataSomaticStatuses === 0 && !loadAll && !loadingClick">
                    Данных нет...
                </p>
            </div>
            <div class="body-right">
                <div class="img-wrap">
                    <skin-human :selectedPropertyObject="selectedPropertyObject" />
                </div>
            </div>
        </div>

        <TimeoutSnackbar :options="snackbar" />
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import InlineSvg from 'vue-inline-svg';
import debounce from 'lodash.debounce';
import TimeoutSnackbar from '@/components/TimeoutSnackbar.vue';
import skinHuman from '../Human/skin.vue';
import Observer from '@/components/VirtualScroll/index.vue';
import AutocompleteComponents from '@/components/Autocomplete/index.vue';

export default {
    name: 'inspection',
    components: {
        InlineSvg,
        TimeoutSnackbar,
        skinHuman,
        Observer,
        AutocompleteComponents
    },
    computed: {
        ...mapGetters({
            apiGuide: 'apiGuide',
            getDiagnostic: 'createDiagnosticTest/getDiagnostic',
            getFlagReadonly: 'createDiagnosticTest/getFlagReadonly'
        }),
        isDisabledProperty() {
            let groupIds = this.params.groupIds;

            if(groupIds && groupIds.length > 0) {
                return false;
            }

            return true
        },
        isDataSomaticStatuses() {
            if(this.getDiagnostic.dataSomaticStatuses && this.getDiagnostic.dataSomaticStatuses.length > 0) {
                return this.getDiagnostic.dataSomaticStatuses.length
            }

            return 0
        },
        isCurrentObjSprPhysResearch() {
            if(this.getDiagnostic.currentObjSprPhysResearch && this.getDiagnostic.currentObjSprPhysResearch.id) {
                return this.getDiagnostic.currentObjSprPhysResearch.id
            }

            return null
        }
    },
    data() {
        return {
            viewOpenIndicators: false,
            localyStatusSystem: '',
            loadingShowMore: false,
            showMoreFinish: false,
            listGroup: [],
            listProperty: [],
            loadListGroup: true,
            loadAll: true,
            loadingClick: false,
            selectedPropertyObject: {
                groupName: '',
                propertyName: '',
                viewImage: false
            },
            snackbar: {
                show: false,
                text: null,
                color: null,
                timeout: -1
            },
            rules: {
                required: (v, text) => (!!v || v === 0) || (text ? text : 'Обязательно для заполнения.'),
                minMax: (v, min, max) => v >= min && v <= max || 'Референс не соблюден!.'
            },
            nameSystemClick: {
                nameLong: ''
            },
            params: {
                groupIds: [],
                propertyIds: [],
                isVisible: false,
                pageSize: 5,
                currentPage: 0
            },
            totalRecords: 0
        }
    },
    methods: {
        ...mapActions({
            getSprPhysResearch: 'createDiagnosticTest/getSprPhysResearch',
            getAllSprBodySystem: 'createDiagnosticTest/getAllSprBodySystem',
            getSomaticStatusBodySystems: 'createDiagnosticTest/getSomaticStatusBodySystems',
            getSomaticStatusesByTestId: 'createDiagnosticTest/getSomaticStatusesByTestId',
            saveInline: 'createDiagnosticTest/saveInline',
            getMediaFilesByPropertyId: 'createDiagnosticTest/getMediaFilesByPropertyId',
            getSprSomaticStatus: 'createDiagnosticTest/getSprSomaticStatus'
        }),
        ...mapMutations({
            changeFlagMissingStep: 'createDiagnosticTest/changeFlagMissingStep',
            saveSelectedProperty: 'createDiagnosticTest/saveSelectedProperty',
            resetFiles: 'createDiagnosticTest/resetFiles',
            saveDataSomaticStatuses: 'createDiagnosticTest/saveDataSomaticStatuses',
            addLocalStatusForIconList: 'createDiagnosticTest/addLocalStatusForIconList'
        }),
        clickSystemFilter(obj, nameVariables) {
            if(this[nameVariables].nameLong === obj.nameLong) {
                return;
            }

            // Добавляем реактивные поля чекбокса и прелоадера
            if(obj.groups && obj.groups.length > 0) {
                for (let i = 0; i < obj.groups.length; i++) {
                    this.$set(obj.groups[i], 'checkbox', false);
                    this.$set(obj.groups[i], 'loadingDisabled', false);
                }
            }

            this.localyStatusSystem = obj.localStatus;
            this.listGroup = obj.groups;
            this[nameVariables] = obj
            obj.loading = true;
            this.loadingClick = true;
            this.selectedPropertyObject = { groupName: '', propertyName: '', viewImage: false };
            this.resetFiles();
            this.filter(obj, false, true, true);
        },
        bodySystemDisabled(id) {
            return this.getDiagnostic.dataSomaticStatusBodySystems.find(x => x.bodySystemId === id) === undefined;
        },
        saveLocalyStatus: debounce( function (obj) {
            this.saveInline(obj)
                .then(() => {
                    this.addLocalStatusForIconList({ id: this.nameSystemClick.id, localStatus: this.localyStatusSystem });
                    this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };
                })
                .catch((error) => {
                    if(error) {
                        this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                    }
                });
        }, 1500),
        save: debounce( function (obj) {
            this.saveInline(obj)
                .then((data) => {
                    obj.obj.isPathology = data.isPathology;
                    obj.obj.edite = false;
                    this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };
                })
                .catch((error) => {
                    if(error) {
                        this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                    }
                });
        }, 1500),
        setListValue(item) {
            let listValue = item.listValues.find(x => x.id === item.listValueId);

            if (listValue) {
                item.listValueName = listValue.name;
            }
        },
        getData(item, index, url) {
            item.edite = !item.edite;

            this.$nextTick(() => {
                if(item.valueType === 1) {
                    if(item.edite) {
                        item.loadSpr = true;
                        // Список для значения
                        this.$http.get(`${this.apiGuide}api/${url}/GetListValues?propertyId=${item.propertyId}`)
                            .then((res) => {
                                this.$refs[`input-${item.id}${index}`][0].focus();
                                item.listValues = res.data;
                                item.loadSpr = false;
                            })
                    }
                } else {
                    this.$refs[`input-${item.id}${index}`][0].focus();
                }
            })
        },
        switchIsVisibleOrPatalogy(obj, nameLoad, nameVal) {
            obj.obj[nameLoad] = true;
            if(nameVal) obj.obj[nameVal] = !obj.obj[nameVal];

            this.saveInline(obj)
                .then(() => {
                    obj.obj[nameLoad] = false;
                    this.snackbar = { text: 'Изменения сохранены успешно!', color: 'success', timeout: 3000, show: true };

                    if(nameVal == 'isVisible') {
                        for (let i = 0; i < this.listGroup.length; i++) {
                            if(!this.listGroup[i].isVisible && obj.obj.isVisible && this.listGroup[i].id === obj.obj.groupId) {
                                this.listGroup[i].isVisible = true;
                            }
                        }
                    }
                })
                .catch((error) => {
                    if(error) {
                        this.snackbar = { text: 'Ошибка сохранения данных, обратитесь к Администратору!', color: 'error', timeout: 3000, show: true };
                    }
                })
        },
        selectedProperty(el) {
            if(this.selectedPropertyObject.propertyName === el.propertyName) {
                return;
            }
            el.loadingImage = true;
            this.getMediaFilesByPropertyId({ testId: this.$route.params.id, propertyId: el.propertyId, type: 2 })
                .then(() => {
                    el.viewImage = true;
                    el.loadingImage = false;
                    this.selectedPropertyObject = el;
                    this.saveSelectedProperty(el);
                })
        },
        selectedGroup(event) {
            if(!event || event.length === 0){
                this.listProperty = [];
                this.params.groupIds = [];
                this.params.propertyIds = [];
                this.filter(null, false, true);

                return;
            }

            this.params.groupIds = event;
            this.listProperty = [];

            for (let i = 0; i < event.length; i++) {
                for (let j = 0; j < this.listGroup.length; j++) {
                    if(event[i] === this.listGroup[j].id) {
                        this.listProperty.push(...this.listGroup[j].indicators)
                    }
                }
            }

            this.filter(null, false, true);
        },
        filter(obj, showMore, reset, resetFilters) {
            if(reset) this.params.currentPage = 0;

            if(resetFilters) {
                this.params.groupIds = [];
                this.params.propertyIds = [];
                this.params.isVisible = false;
                this.viewOpenIndicators = false;
                this.$root.$emit('resetSelected');
                this.getSomaticStatusBodySystems({testId: this.$route.params.id, physResearchId: this.getDiagnostic.currentObjSprPhysResearch.id, isVisible: false});
            }

            return new Promise((resolve, reject) => {
                this.getSomaticStatusesByTestId({
                    testId: this.$route.params.id,
                    bodySystemId: this.nameSystemClick.id,
                    physResearchId: this.getDiagnostic.currentObjSprPhysResearch.id,
                    params: this.params,
                    showMore: showMore
                })
                .then((res) => {
                    if(res.totalRecords === this.isDataSomaticStatuses) {
                        this.showMoreFinish = true;
                    } else {
                        this.showMoreFinish = false;
                    }

                    this.totalRecords = res.totalRecords;
                    if(obj) obj.loading = false;
                    this.loadingClick = false;
                    this.loadListGroup = false;
                    this.loadAll = false;
                    resolve(res);
                })
                .catch((error) => {
                    reject(error)
                })
            })
        },
        showMoreFunc(params) {
            if(this.showMoreFinish) {
                return;
            }

            this.loadingShowMore = true;
            params.currentPage++;

            this.filter(this.nameSystemClick, true, false)
                .then(() => {
                    this.loadingShowMore = false;
                })
        },
        viewOrNot(event) {
            this.params.groupIds = event;
            this.saveDataSomaticStatuses([]);
            this.loadAll = true;
            this.filter(null, false, true);
        },
        showOnlyOpenIndicators(value) {
            this.saveDataSomaticStatuses([]);
            this.loadAll = true;
            this.params.isVisible = value;

            this.getSomaticStatusBodySystems({
                testId: this.$route.params.id,
                physResearchId: this.getDiagnostic.currentObjSprPhysResearch.id,
                isVisible: value
            })
            .then(() => {
                this.filter(this.nameSystemClick, this.isDataSomaticStatuses > 0, true, false);
            })
        }
    },
    destroyed() {
        this.saveDataSomaticStatuses([]);
    },
    created() {
        // Если предыдущая нумерация пропущена и у этой нумерации состояние 1/3 то вызываем окно с подтверждением
        if(this.getDiagnostic.methods === 'skip' && this.getDiagnostic.levels[3].visibleType !== 2) {
            this.changeFlagMissingStep({ flag: true, index: 3 });
        }

        this.getSprPhysResearch('Пальпация')
            .then(() => {
                this.getSomaticStatusBodySystems({ testId: this.$route.params.id, physResearchId: this.getDiagnostic.currentObjSprPhysResearch.id })
                    .then(() => {
                        this.getAllSprBodySystem()
                            .then(() => {
                                if (this.getDiagnostic.dataSomaticStatusBodySystems.length > 0) {
                                    let enabledBodySystems = this.getDiagnostic.dataSomaticStatusBodySystems.map(x => x.bodySystemId);
                                    let icon = this.getDiagnostic.iconsList.find(x => enabledBodySystems.includes(x.id));
                                    this.clickSystemFilter(icon, 'nameSystemClick');
                                }

                                this.loadAll = false;
                            });
                    })

            });

    }
}
</script>